package org.mkui.canvas

import web.mouse.AUXILIARY
import web.mouse.MAIN
import web.mouse.MouseButton

class JSMouseEvent(private val event: web.mouse.MouseEvent, override val clickCount: Int) : MouseEvent {
    override val x: Int
        get() = event.offsetX.toInt()
    override val y: Int
        get() = event.offsetY.toInt()
    override val isMenuShortcutKeyDown: Boolean
        get() = event.ctrlKey || event.metaKey
    override val isMultipleSelectionKey: Boolean
        get() = event.ctrlKey || event.metaKey
    override val isAltKeyDown: Boolean
        get() = event.altKey
    override val isShiftKeyDown: Boolean
        get() = event.shiftKey
    override val isPopupTrigger: Boolean
        get() = false
    override val isLeftMouseButton: Boolean
        get() = event.button == MouseButton.MAIN
    override val isMiddleMouseButton: Boolean
        get() = event.button == MouseButton.AUXILIARY

    override fun stopPropagation() {
        event.stopPropagation()
    }
}